import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../api/client";
import ENDPOINTS from "../../api/endpoints";
import { showNotification } from "../Notifications/notificationsSlice";

export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (
    { page = 1, filters = [], sortModel = [] },
    { getState, rejectWithValue }
  ) => {
    try {
      const state = getState().users;
      const { pageSize } = state;
      const params = new URLSearchParams();

      params.set("page", page);
      params.set("pageSize", pageSize);

      if (filters.length > 0) {
        params.set("filters", JSON.stringify(filters));
      }

      if (sortModel.length > 0) {
        const { field, sort } = sortModel[0];
        params.set("sortField", field);
        params.set("sortOrder", sort);
      }

      const response = await apiClient.get(
        `${ENDPOINTS.USERS.USERS}?${params.toString()}`
      );

      console.log("Fetched users:", response.data);

      return { data: response.data, page };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const addUsers = createAsyncThunk(
  "users/addUsers",
  async (userData, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiClient.post(ENDPOINTS.USERS.USERS, userData);
      dispatch(
        showNotification({
          message: "User added successfully!",
          type: "success",
        })
      );
      return response.data;
    } catch (error) {
      dispatch(
        showNotification({
          message: "Failed to add user.",
          type: "error",
        })
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateUsers = createAsyncThunk(
  "users/updateUsers",
  async ({ id, ...userData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await apiClient.patch(
        `${ENDPOINTS.USERS.USERS}/${id}`,
        userData
      );
      dispatch(
        showNotification({
          message: "User updated successfully!",
          type: "success",
        })
      );
      return response.data;
    } catch (error) {
      dispatch(
        showNotification({
          message: "Failed to update user.",
          type: "error",
        })
      );
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
